import { useEffect, useState } from 'react';
import { getPendingCount } from '@/services/progressSync';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

/**
 * Displays sync queue status and pending item count.
 * Updates periodically and when online status changes.
 */
export default function SyncStatus() {
  const isOnline = useOnlineStatus();
  const [pendingCount, setPendingCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const updateCount = async () => {
    try {
      const count = await getPendingCount();
      setPendingCount(count);
    } catch (error) {
      console.error('[SyncStatus] Failed to get pending count:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    updateCount();
    const interval = setInterval(updateCount, 30000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (isOnline) {
      updateCount();
    }
  }, [isOnline]);

  if (isLoading || pendingCount === 0) {
    return null;
  }

  return (
    <div
      data-testid="sync-status"
      className="fixed bottom-4 right-4 z-50 transition-opacity duration-300"
      role="status"
      aria-live="polite"
    >
      <div className="bg-blue-500 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-2">
        <span className="text-lg" aria-hidden="true">🔄</span>
        <span className="font-medium">
          {pendingCount} {pendingCount === 1 ? 'item' : 'items'} pending sync
        </span>
      </div>
    </div>
  );
}
